import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_COURSE_TYPE_OPTIONS,
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import Select from 'components/Select';
import styles from './CourseTypeFilter.module.scss';

function CourseTypeFilter() {
  const dispatch = useDispatch();
  const { courseType } = useSelector(currentFiltersSelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.courseType,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Course Type"
      labelClassName="h5"
      className={styles.root}
    >
      <Select
        styles={_styles}
        options={COURSE_PAUSE_REQUEST_COURSE_TYPE_OPTIONS}
        value={courseType}
        onChange={handleOnChange}
        menuPlacement="auto"
      />
    </Field>
  );
}

export default CourseTypeFilter;
